import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';

import { PhoneInput } from '../../common';
import { fetchCompanyBudgetGroups, addWorkerToCompany, editEntityField } from '../../../actions';

class WorkerEditor extends Component {

    componentWillMount() {
        if (!this.props.budgetGroups.length && this.props.companyId) {
            this.props.fetchCompanyBudgetGroups(this.props.companyId);
        }
    }

    handleSubmit = (event) => {
        this.props.addWorkerToCompany(this.props.companyId, this.props.entity);
        event.preventDefault();
    }

    render() {
        if (!this.props.entity) {
            return null;
        }

        const worker = this.props.entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <PhoneInput
                        value={this.props.entity.phone}
                        onChange={(phone) => this.props.editEntityField('phone', phone)}
                    />
                </Form.Field>

                <Form.Field>
                    <label>{i18next.t('budget')}</label>
                    <Dropdown
                        required
                        fluid
                        selection
                        options={this.props.budgetGroups.map((group) => ({ value: group.id, text: group.name }))}
                        value={worker.budgetGroupId || ''}
                        onChange={(e, { value }) => this.props.editEntityField('budgetGroupId', value)}
                    />
                </Form.Field>

                <Form.Group>
                    <Button type='submit' primary floated="right">
                        {i18next.t('save')}
                    </Button>
                </Form.Group>

            </Form>
        );
    }
}

WorkerEditor.propTypes = {
    companyId: PropTypes.any,
    fetchCompanyBudgetGroups: PropTypes.func,
    addWorkerToCompany: PropTypes.func,
    editEntityField: PropTypes.func,
    entity: PropTypes.object,
    budgetGroups: PropTypes.array
    
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;
    const { budgetGroups } = state.budgetsApp;

    return { entity, budgetGroups };
};

export default connect(mapStateToProps, { fetchCompanyBudgetGroups, addWorkerToCompany, editEntityField })(WorkerEditor);
